const lifestyleToolsEndpoint = '/api/health/api/lifestyle-tools'

const getLifestyle = async (userId: string, token: string) => {
	if (!userId) throw new Error('No user ID provided')
	if (!token) throw new Error('No token provided')

	return await fetch(`${lifestyleToolsEndpoint}/lifestyle/${userId}`, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		}
	})
}

const getLifestyleHistory = async (userId: string, token: string) => {
	if (!userId) throw new Error('No user ID provided')
	if (!token) throw new Error('No token provided')

	return await fetch(`${lifestyleToolsEndpoint}/lifestyle/${userId}/history`, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		}
	})
}

const createLifestyle = async (data: object, token: string) => {
	if (!data) throw new Error('No lifestyle data provided')
	if (!token) throw new Error('No token provided')

	return await fetch(`${lifestyleToolsEndpoint}/lifestyle`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		},
		body: JSON.stringify(data)
	})
}

const getWheel = async (userId: string, token: string) => {
	if (!userId) throw new Error('No user ID provided')
	if (!token) throw new Error('No token provided')

	return await fetch(`${lifestyleToolsEndpoint}/wheel/${userId}`, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		}
	})
}

const getWheelHistory = async (userId: string, token: string) => {
	if (!userId) throw new Error('No user ID provided')
	if (!token) throw new Error('No token provided')

	return await fetch(`${lifestyleToolsEndpoint}/wheel/${userId}/history`, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		}
	})
}

const createWheel = async (data: object, token: string) => {
	if (!data) throw new Error('No wheel data provided')
	if (!token) throw new Error('No token provided')

	return await fetch(`${lifestyleToolsEndpoint}/wheel`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		},
		body: JSON.stringify(data)
	})
}

const getEnergy = async (userId: string, token: string) => {
	if (!userId) throw new Error('No user ID provided')
	if (!token) throw new Error('No token provided')

	return await fetch(`${lifestyleToolsEndpoint}/energy/${userId}`, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		}
	})
}

const createEnergy = async (data: object, token: string) => {
	if (!data) throw new Error('No energy data provided')
	if (!token) throw new Error('No token provided')

	return await fetch(`${lifestyleToolsEndpoint}/energy`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		},
		body: JSON.stringify(data)
	})
}

const getVitals = async (userId: string, token: string) => {
	if (!userId) throw new Error('No user ID provided')
	if (!token) throw new Error('No token provided')

	return await fetch(`${lifestyleToolsEndpoint}/vitals/${userId}`, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		}
	})
}

const createVitals = async (data: object, token: string) => {
	if (!data) throw new Error('No vitals data provided')
	if (!token) throw new Error('No token provided')

	return await fetch(`${lifestyleToolsEndpoint}/vitals`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		},
		body: JSON.stringify(data)
	})
}

const createWater = async (data: object, token: string) => {
	if (!data) throw new Error('No water data provided')
	if (!token) throw new Error('No token provided')

	return await fetch(`${lifestyleToolsEndpoint}/water`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		},
		body: JSON.stringify(data)
	})
}

export {
	getLifestyle,
	getLifestyleHistory,
	createLifestyle,
	getWheel,
	getWheelHistory,
	createWheel,
	getEnergy,
	createEnergy,
	getVitals,
	createVitals,
	createWater
}
